<template>
<div class="chapter">
<div class="inner_page">
<div class="acknowledgments" id="ack">
<h1 class="chapter1">Acknowledgments</h1>
<p class="nonindent">Special thanks to: Bob Gleason and Eric Raab for guidance on a number of issues; Meg Ruley for her sharp insight and unending support; Justin Golenbock for his efforts to publicize my novels; Matthew Kuhn for his help in explaining the mysteries of websites; Florida statewide prosecutor William Shepard for his incredible support through all my novels; and Buch Buchanan for outstanding editing and proofreading skills.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781429949323_epub_ack_r1.vue?060e43f8